import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";

const CATEGORIES = ["cases", "headphones", "chargers", "power_banks", "small_accessories"];

export default function Shop() {
  const { category } = useParams();
  const { t } = useLanguage();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/products", { params: category ? { category } : {} })
      .then(({ data }) => setProducts(data))
      .finally(() => setLoading(false));
  }, [category]);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 page-enter">
      <div className="mb-10">
        <div className="text-xs uppercase tracking-widest text-[#D4AF37] mb-2">M16</div>
        <h1 className="font-display text-4xl lg:text-5xl">
          {category ? t(category) : t("allProducts")}
        </h1>
      </div>

      <div className="flex flex-wrap gap-2 mb-10">
        <Link
          to="/shop"
          data-testid="filter-all"
          className={`px-4 py-2 rounded-full text-xs border transition-all ${
            !category ? "bg-[#D4AF37] text-black border-[#D4AF37]" : "border-[#27272A] hover:border-[#D4AF37] hover:text-[#D4AF37]"
          }`}
        >
          {t("allProducts")}
        </Link>
        {CATEGORIES.map((c) => (
          <Link
            key={c}
            to={`/shop/${c}`}
            data-testid={`filter-${c}`}
            className={`px-4 py-2 rounded-full text-xs border transition-all ${
              category === c
                ? "bg-[#D4AF37] text-black border-[#D4AF37]"
                : "border-[#27272A] hover:border-[#D4AF37] hover:text-[#D4AF37]"
            }`}
          >
            {t(c)}
          </Link>
        ))}
      </div>

      {loading ? (
        <div className="text-center py-20 text-[#9CA3AF]">…</div>
      ) : products.length === 0 ? (
        <div className="text-center py-20 text-[#9CA3AF]">—</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 stagger" data-testid="shop-grid">
          {products.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      )}
    </div>
  );
}
